<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolFreshVFS_1d00_P10"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolFreshVFS_1d00_P10 from '@/device-products/ResolDeltaSolFreshVFS_1d00_P10.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolFreshVFS_1d00_P10, deviceLabel: 'Codierung 1: VFS', props: { leiterplattenCodierung: 1 } },
    ],
  }),
};
</script>

<style>

</style>
